import {Component, OnDestroy, OnInit} from '@angular/core';
import {Location} from "@angular/common";

@Component({
  selector: 'vb-redirect-to-vtouch',
  templateUrl: './redirect-to-vtouch.component.html',
  styleUrls: ['./redirect-to-vtouch.component.css']
})
export class RedirectToVtouchComponent implements OnInit, OnDestroy {

  private timeout;

  constructor(private loc: Location) {
  }

  ngOnInit() {
    this.timeout = setTimeout(() => {
      window.location.assign('http://vtouch.test');
    }, 5000);
  }

  onCancelClicked() {
    this.loc.back();
  }

  ngOnDestroy(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/vtouch/redirect-to-vtouch/redirect-to-vtouch.component.ts